module.exports = "/_next/static/images/cc75f41cfedc97500b2fc650472da3b8-join-us-xs-2x.png";